import React from 'react';
import Modal from './Modal';
import Button from '../shared/ui/Button';
import styles from './ConfirmDialog.module.css';

/**
 * In-app confirm (replaces window.confirm). Stacks above other modals by default.
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  loading = false,
  zIndex = 2400
}) {
  return (
    <Modal
      open={open}
      onClose={loading ? undefined : onClose}
      title={title}
      description={description}
      size="sm"
      closeOnBackdrop={!loading}
      closeOnEscape={!loading}
      closeDisabled={loading}
      showClose={!loading}
      zIndex={zIndex}
      footer={
        <div className={styles.footer}>
          <Button type="button" variant="secondary" size="md" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant={variant === 'danger' ? 'danger' : 'primary'}
            size="md"
            onClick={onConfirm}
            loading={loading}
          >
            {confirmLabel}
          </Button>
        </div>
      }
    />
  );
}
